import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from '@mui/material/Alert';
import { AlertTitle, Stack } from '@mui/material';

import {
  getHasVideoBucketUploadFailed,
  getBucketUploadError,
  getMediaSubmissionError,
  retryUpload,
  getCampaignLanguage,
} from '../../redux/modules/campaignLandingPage';
import { VpButton } from '@vp-ui/components';
import { getTranslation } from '@src/translations/dictionary';

const UploadError = ({
  _retryUpload,
  qid,
  hasUploadFailure,
  bucketError,
  mediaSubmissionError,
  language
}) => {
  if (!hasUploadFailure && !mediaSubmissionError) {
    return null;
  }

  const errorAlertTitle = getTranslation('error_alert_title', language);
  const retryButtonLabel = getTranslation('retry_button_label', language);

  const errorMessage =
    bucketError ||
    mediaSubmissionError ||
    'Please make sure you uploaded the correct file.';

  return (
    <Stack sx={{ width: '100%' }} spacing={2}>
      <Alert
        severity="error"
        action={
          <VpButton
            color='inherit'
            onClick={() => _retryUpload(qid)}
          >
            {retryButtonLabel}
          </VpButton>
        }
      >
      <AlertTitle color='inherit'>{errorAlertTitle}</AlertTitle>
        {errorMessage} 
      </Alert>
    </Stack>
  );
};

UploadError.propTypes = {
  hasUploadFailure: PropTypes.bool,
  bucketError: PropTypes.string,
  language: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  return {
    hasUploadFailure: getHasVideoBucketUploadFailed(state, ownProps.qid),
    bucketError: getBucketUploadError(state, ownProps.qid),
    mediaSubmissionError: getMediaSubmissionError(state, ownProps.qid),
    language: getCampaignLanguage(state)
  };
}

const mapDispatchToProps = {
  _retryUpload: retryUpload,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadError);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/UploadError.jsx